module.exports = __webpack_public_path__ + "8e5e95c5d417774847d9f24db6fe18b0.png";